__turbopack_context__.v({
  "button": "ApplyComplete-module__7E58lG__button",
  "container": "ApplyComplete-module__7E58lG__container",
  "fadeInItems": "ApplyComplete-module__7E58lG__fadeInItems",
  "spacing--lg": "ApplyComplete-module__7E58lG__spacing--lg",
  "spacing--md": "ApplyComplete-module__7E58lG__spacing--md",
  "spacing--sm": "ApplyComplete-module__7E58lG__spacing--sm",
  "spacing--xl": "ApplyComplete-module__7E58lG__spacing--xl",
  "spacing--xs": "ApplyComplete-module__7E58lG__spacing--xs",
  "spacing--xxl": "ApplyComplete-module__7E58lG__spacing--xxl",
  "spacing--xxs": "ApplyComplete-module__7E58lG__spacing--xxs",
  "spacing--xxxl": "ApplyComplete-module__7E58lG__spacing--xxxl",
  "spacing--xxxs": "ApplyComplete-module__7E58lG__spacing--xxxs",
  "text": "ApplyComplete-module__7E58lG__text",
  "title": "ApplyComplete-module__7E58lG__title",
});
